<template>
  <div
    v-show="layerShow"
    id="select-layer-box"
    class="select-layer"
    @click="hiddenLayer($event)"
  >
    <ul
      v-if="listData.length > 1"
      class="dt-source-unfold"
    >
      <li>
        <h4 class="dt-source-unfold-title">
          {{ selectTitle }}
        </h4>
      </li>
      <li
        v-for="(item, index) in listData"
        :key="index"
        :class="getName(item) === getName(curData) ? 'source-cur' : ''"
        @click="changeOption(item, index, $event)"
      >
        <a
          href="javascript:void(0);"
          uigs="btn_source"
          class="dt-source-item"
        >
          <SiteIcon :icon-img="getIcon(item)" />
          <span>{{ getName(item) }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import SiteIcon from '../../common/components/SiteIcon';

export default {
  components: {
    SiteIcon,
  },
  props: {
    pitem: {
      type: Object,
      default: () => {},
    },
    getName: {
      type: Function,
      default: item => item.name,
    },
    layerShow: {
      type: Boolean,
      default: false,
    },
    getIcon: {
      type: Function,
      default: item => item.icon,
    },
    curData: {
      type: Object,
      default: () => {},
    },
    listData: {
      type: Array,
      default: () => [],
    },
    selectTitle: {
      type: String,
      default: '',
    },
  },
  watch: {
    layerShow(newV) {
      if (newV) {
        this.showLayer();
      } else {
        this.hiddenLayer();
      }
    },
  },
  methods: {
    showLayer() {
      const bodyEl = document.body;
      window.theTop = window.scrollY;
      bodyEl.style.position = 'fixed';
      bodyEl.style.width = '100%';
      bodyEl.style.top = `${-window.theTop}px`;
    },
    hiddenLayer(event) {
      // 自定义 hidden hidden-layer 事件
      this.$emit('hidden-layer');
      const bodyEl = document.body;
      bodyEl.style.position = '';
      bodyEl.style.top = '';
      // 回到原先的top
      window.scrollTo(0, window.theTop || 0);
      if (event) {
        event.stopPropagation();
      }
    },
    changeOption(item, optionIndex, event) {
      this.$emit('change-list-item', item, optionIndex, this.pitem);
      this.hiddenLayer();
      if (event) {
        event.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss">
.select-layer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999; //头部z-index=22, 回到头部z-index=10
  .dt-source-unfold {
    position: absolute;
    background: #fff;
    border-radius: 3px;
    color: rgba(153, 153, 153, 1);
    font-size: 15px;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 12px 12px 0px 0px;
    padding-bottom: 8px;
    max-height: 442px;
    overflow-y: scroll;
    overflow-x: hidden;
    li {
      height: 48px;
      line-height: 48px;
      padding: 0 16px;
      color: #555;
      .dt-source-unfold-title {
        font-size: 16px;
        font-weight: bold;
        color: rgba(34, 34, 34, 1);
        text-align: center;
      }
      .dt-source-item {
        display: block;
        span {
          display: inline-block;
          line-height: 48px;
          color: #555;
        }
        .icon-site {
          margin-top: -4px;
        }
      }
    }
    .source-cur {
      .dt-source-item {
        span {
          font-weight: bold;
          color: rgba(34, 34, 34, 1);
        }
      }
      display: flex;
      align-items: center;
      background: rgba(248, 248, 248, 1);
      &:after {
        margin-top: -2px;
        position: absolute;
        right: 16px;
        display: block;
        content: '';
        width: 5px;
        height: 9px;
        border-color: #555555;
        border-style: solid;
        border-width: 0 1px 1px 0;
        transform: rotate(45deg);
      }
    }
    a {
      display: block;
    }
  }
}
</style>
